export const getAuthProviderRedirectUrl = (): string => {
  const { VUE_APP_DIGI_USERS_F } = process.env;
  const path = window.location.pathname;
  const query = window.location.search;
  const redirect = encodeURIComponent(`${path}${query}`);

  return `${VUE_APP_DIGI_USERS_F}/auth/provider?app=calendar&redirect=${redirect}`;
};
